// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React from "react";
import { AUTHOR_CONTACT_TYPE } from "@/types/enum.ts";
import { useTranslation } from "@/shared/hooks/useTranslation.tsx";

export interface AuthorContactBtnProps {
  btnType: AUTHOR_CONTACT_TYPE;
  link: string;
}

export default function AuthorContactBtn(props: AuthorContactBtnProps) {
  const { t } = useTranslation();
  const iconSrc = getAuthorContactIconSrc(props.btnType);
  const text = getAuthorContactText(props.btnType, t);

  const onClickBtn = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (props.btnType === AUTHOR_CONTACT_TYPE.EMAIL) {
      try {
        await navigator.clipboard.writeText(props.link);
        alert(t("contact.emailCopy"));
      } catch (err) {
        alert(t("common.error"));
        console.log(err);
      }
    } else {
      window.open(props.link, "_blank");
    }
  };
  return (
    <div className="author-contact-wrapper" onClick={(e) => onClickBtn(e)}>
      <img src={`/assets/icons/${iconSrc}.svg`} />
      <div className="link-href">{text}</div>
      {props.btnType === AUTHOR_CONTACT_TYPE.INSTAGRAM ||
      props.btnType === AUTHOR_CONTACT_TYPE.LINKEDIN ? (
        <img src={"/assets/icons/ArrowUpRight.svg"} />
      ) : null}
    </div>
  );
}

export function getAuthorContactIconSrc(props: AUTHOR_CONTACT_TYPE) {
  switch (props) {
    case AUTHOR_CONTACT_TYPE.EMAIL:
      return "FiEmail";
    case AUTHOR_CONTACT_TYPE.INSTAGRAM:
      return "InstagramLogo";
    case AUTHOR_CONTACT_TYPE.LINKEDIN:
      return "LinkedinLogo";
    case AUTHOR_CONTACT_TYPE.ARTICLE_LINK:
      return "FiLink";
    case AUTHOR_CONTACT_TYPE.SOURCE_INFO:
      return "FiInfo";
  }
}

function getAuthorContactText(props: AUTHOR_CONTACT_TYPE, t: any) {
  switch (props) {
    case AUTHOR_CONTACT_TYPE.EMAIL:
      return t("contact.emailCopy");
    case AUTHOR_CONTACT_TYPE.INSTAGRAM:
      return t("contact.instagram");
    case AUTHOR_CONTACT_TYPE.LINKEDIN:
      return t("contact.linkedin");
    case AUTHOR_CONTACT_TYPE.ARTICLE_LINK:
      return t("contact.articleShare");
    case AUTHOR_CONTACT_TYPE.SOURCE_INFO:
      return t("contact.sourceInfo");
  }
}
